import {
    CopyOutlined,
    DollarOutlined,
    FolderOpenOutlined,
} from "@ant-design/icons";
import { App, Button, Flex, Image, Tooltip } from "antd";
import { Point } from "tm-shared/types";

import { PrimaryText, SecondaryText } from "@/shared/ui/Typography";
import { copyObjectToClipboard } from "@/utils/dom/copyObjectToClipboard";
import { getFileUrl } from "@/utils/file/getFileUrl";

import {
    StyledAPHeader,
    StyledAPImageWrapper,
    StyledBadge,
    StyledBadgeContainer,
} from "../Styled";

export const HeaderBlock = ({ point }: { point: Point }) => {
    const { notification } = App.useApp();
    const imageURL = getFileUrl(point.market.building.photo);

    const handleCopyAddress = () => {
        copyObjectToClipboard(point.market.building.address, notification);
    };

    const badges = [
        {
            key: "debt",
            visible: point.hasDebt || point.hasDebtCritical,
            title: "Торгова точка має заборгованість",
            bg: "error" as const,
            icon: <DollarOutlined />,
        },
        {
            key: "archived",
            visible: point.market.isArchived,
            title: "Торгова точка є архівною",
            bg: "warning" as const,
            icon: <FolderOpenOutlined />,
        },
    ].filter((b) => b.visible);

    return (
        <StyledAPHeader>
            <StyledAPImageWrapper>
                {badges.length > 0 && (
                    <StyledBadgeContainer>
                        {badges.map((b) => (
                            <Tooltip key={b.key} title={b.title}>
                                <StyledBadge $background={b.bg}>
                                    {b.icon}
                                </StyledBadge>
                            </Tooltip>
                        ))}
                    </StyledBadgeContainer>
                )}
                <Image src={imageURL} alt={point.id} />
            </StyledAPImageWrapper>

            <Flex vertical gap={4}>
                <PrimaryText fontSize={16}>
                    {point.market.contragent.name}
                </PrimaryText>
                <Flex gap={4} align="center">
                    <SecondaryText>
                        {point.market.building.address?.name}
                    </SecondaryText>
                    <Button
                        style={{ flexShrink: 0 }}
                        icon={<CopyOutlined />}
                        type="text"
                        onClick={handleCopyAddress}
                    />
                </Flex>
            </Flex>
        </StyledAPHeader>
    );
};
